import type { SupplierConfig } from '../../../domain/types/configs/company/SupplierConfig';

export const supplierConfig: SupplierConfig = {
  providers: [
    {
      value: "BOSTON SCIENTIFIC CORPORATION",
      id: "EB23",
      noCia: "1"
    },
    {
      value: "FRESENIUS MEDICAL CARE PANAMA, S.A",
      noCia: "1",
      id: "EF37"
    },
    {
      value: "GE HEALTHCARE GE PRECISION HEALTHCARE LLC",
      noCia: "1",
      id: "EG03"
    },
    {
      id: "EG15",
      noCia: "1",
      value: "GE MEDICAL SYSTEMS INFORMATION TECHNOLOGIES INC"
    },
    {
      id: "ES32",
      noCia: "1",
      value: "STERIS"
    },
    {
      value: "FRESENIUS MEDICAL CARE (ALEMANIA)",
      id: "EF07",
      noCia: "1"
    },
    {
      noCia: "1",
      id: "EF12",
      value: "FRESENIUS KABI"
    },
    {
      noCia: "1",
      value: "FRESENIUS MEDICAL CARE ANDINA S.A.S.",
      id: "EF26"
    }
  ]
}; 